export const SET_RESPOND_TO_BRAINDATE = 'SET_RESPOND_TO_BRAINDATE';
